import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/signin';
import Container from '../../containers/app';
import Root from '../../components/root';

export default function PageSignin() {
  return (
    <Root title={PAGE_TITLE.SIGNIN}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
